import {readTreasuryTransactionsQuery} from './treasury-transaction-requests.js';
export class TreasuryPaymentIntentRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid Treasury payment-intent read request: ${detail}`);
    this.name = 'TreasuryPaymentIntentRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
export function readPaymentIntentIdentifier(value) {
  if (typeof value !== 'string' || !/^[a-f0-9]{24}$/i.test(value)) throw new TreasuryPaymentIntentRequestContractError('expected a valid id.');
  return value;
}
export function readPaymentIntentQuery(query = {}) {
  try {return readTreasuryTransactionsQuery(query);}
  catch {throw new TreasuryPaymentIntentRequestContractError('expected a scalar decimal limit.');}
}
